export default function Warning() {
  return null;
}
